import classNames from "classnames";
import SimpleErrorMessage from "components/InputsMex/containers/SimpleErrorMessage";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import SimpleContainer from "./containers/SimpleContainer";
import {
  DropDownDate,
  DropDownFilter,
  PrimeTextInput,
  TextInput,
  TextInputMask,
} from "./inputs";
import { RawPasswordInput } from "./RawInputs";
import { Button } from "primereact/button";

export const SimpleTextInputField = ({
  name,
  label,
  rules,
  disabled = false,
  helpText,
  containerProps = {},
  onBlur = null,
  maxLength,
}) => {
  return (
    <React.Fragment>
      <SimpleContainer label={label} name={name} helpText={helpText} {...containerProps}>
        <TextInput
          inputProps={{ name, readOnly: disabled, onBlur, maxLength }}
          rules={{ ...rules }}
        />
      </SimpleContainer>
    </React.Fragment>
  );
};

export const SimpleNumberIntInputField = ({
  name,
  label,
  rules,
  helpText,
  containerProps = {},
  disabled,
  ...rest
}) => {
  return (
    <React.Fragment>
      <SimpleContainer label={label} name={name} helpText={helpText} {...containerProps}>
        <PrimeTextInput
          name={name}
          disabled={disabled}
          rules={rules}
          keyfilter='int'
          {...rest}
        />
      </SimpleContainer>
    </React.Fragment>
  );
};

export const SimpleNumberInputField = ({
  name,
  label,
  rules,
  helpText,
  containerProps = {},
}) => {
  return (
    <React.Fragment>
      <SimpleContainer label={label} name={name} helpText={helpText} {...containerProps}>
        <TextInput inputProps={{ name }} rules={rules} />
      </SimpleContainer>
    </React.Fragment>
  );
};

export const SimpleDropDownDateInputField = ({
  name,
  label,
  rules,
  helpText,
  containerProps = {},
  ...rest
}) => {
  return (
    <React.Fragment>
      <SimpleContainer label={label} name={name} helpText={helpText} {...containerProps}>
        <DropDownDate name={name} rules={rules} {...rest} />
      </SimpleContainer>
    </React.Fragment>
  );
};

export const SimpleDropDownInputField = ({
  name,
  label,
  rules,
  onChangeFn,
  options,
  defaultValue,
  helpText,
  containerProps = {},
  optionLabel = "label",
  optionValue = "value",
  ...rest
}) => {
  return (
    <React.Fragment>
      <SimpleContainer label={label} name={name} helpText={helpText} {...containerProps}>
        <DropDownFilter
          name={name}
          optionLabel={optionLabel}
          optionValue={optionValue}
          defaultValue={defaultValue}
          onChangeFn={onChangeFn}
          options={options}
          rules={rules}
          {...rest}
        />
      </SimpleContainer>
    </React.Fragment>
  );
};

export const SimplePasswordInputField = ({
  name,
  label,
  rules = {},
  helpText,
  containerProps = {},
  ...rest
}) => {
  const { register } = useFormContext();
  return (
    <React.Fragment>
      <SimpleContainer label={label} name={name} helpText={helpText} {...containerProps}>
        <RawPasswordInput name={name} inputRef={register(rules)} {...rest} />
      </SimpleContainer>
    </React.Fragment>
  );
};

export const SimpleMaskInputField = ({
  name,
  label,
  rules = {},
  helpText,
  containerProps = {},
  classContainer = "",
  disabled,
  mask,
  placeholder,
  defaultValue = null,
  unmask = true,
  replaces = [],
  ...rest
}) => {
  return (
    <SimpleContainer
      label={label}
      name={name}
      classContainer={classContainer}
      helpText={helpText}
      {...containerProps}>
      <TextInputMask
        //inputProps={{ name, readOnly: disabled }}
        rules={{ ...rules }}
        mask={mask}
        placeholder={placeholder}
        name={name}
        replaces={replaces}
        unmask={unmask}
        defaultValue={defaultValue}
      />
    </SimpleContainer>
  );
};

export const SimpleCheckBox = ({
  name,
  label,
  containerClassName,
  rules = {},
  defaultValue = false,
  id,
  type = "normal",
  labelClass = "disclaimers-auto",
  info = "",
  infoAdicionalLabel = "",
  disabled = false,
  onChangeFn,
}) => {
  return (
    <div className={classNames("d-flex flex-row", containerClassName)}>
      <Controller
        name={name}
        defaultValue={defaultValue}
        rules={rules}
        render={({ value, onChange }) => (
          <div className='text-center' style={{ width: "30px" }}>
            <input
              type='checkbox'
              id={name}
              className='chek-terminos'
              disabled={disabled}
              checked={value}
              onChange={(evt) => {
                const checked = evt.target.checked;
                onChange(checked);
                onChangeFn && onChangeFn(checked, evt);
              }}
            />
            {type === "slide" && (
              <label htmlFor={name} className='check-type-slide'></label>
            )}
          </div>
        )}
      />
      <div className='col-12'>
        <label htmlFor={name} className={labelClass}>
          {label}
          {info != "" && (
            <Button
              type='button'
              label=''
              icon='pi pi-question'
              tooltip={info}
              className='info-cob'
              tooltipOptions={{ position: "top" }}
            />
          )}
          <br></br>
          <SimpleErrorMessage name={name} />
          {infoAdicionalLabel != "" && (
            <div
              dangerouslySetInnerHTML={{
                __html: infoAdicionalLabel,
              }}
            />
          )}
        </label>
      </div>
    </div>
  );
};

export const SimpleCheckBoxCoberturas = ({
  name,
  label,
  rules = {},
  defaultValue = false,
  id,
  type = "normal",
  labelClass = "form-check-label",
}) => {
  return (
    <div className={"row w-100"}>
      <Controller
        name={name}
        defaultValue={defaultValue}
        rules={rules}
        render={({ value, onChange }) => (
          <div className='col-12 form-check'>
            <input
              type='checkbox'
              id={id}
              className='chek-cobertura-style form-check-input'
              checked={value}
              onChange={(evt) => {
                onChange(evt.target.checked);
              }}
            />
            {type === "slide" && (
              <label htmlFor={name} className='check-type-slide'></label>
            )}
            <label htmlFor={name} className={labelClass}>
              {label}
              <br></br>
              <SimpleErrorMessage name={name} />
            </label>
          </div>
        )}
      />
      {/* <div className="col-12 col-sm-11">
        <label htmlFor={name} className={labelClass}>
          {label}
          <br></br>
          <SimpleErrorMessage name={name} />
        </label>
      </div> */}
    </div>
  );
};
